export const getMiniMapSize = () => {
  let size = 0;
  if (window.innerWidth <= 425) {
    size = 150 * (window.innerWidth / 425);
  } else if (window.innerWidth <= 768) {
    size = 200;
  } else if (window.innerWidth <= 1024) {
    size = 200;
  } else if (window.innerWidth <= 1440) {
    size = 300;
  } else if (window.innerWidth <= 2560) {
    size = 350;
  }
  return size;
};

export const STATE_SELECTION = {
  ifc: "ifc",
  obj: "floor",
} as const